<template>
    <div class="dropdown dropup">
        <button type="button" class="btn btn-ghost-secondary btn-icon rounded-circle" id="selectThemeDropdown" data-bs-toggle="dropdown" aria-expanded="false" data-bs-dropdown-animation>
            <i class="bi-info-palette"></i>
        </button>
        <div class="dropdown-menu navbar-dropdown-menu navbar-dropdown-menu-borderless" aria-labelledby="selectThemeDropdown">
            <a class="dropdown-item" href="#" data-icon="bi-moon-stars" data-value="auto">
                <i class="bi-moon-stars me-2"></i>
                <span class="text-truncate" title="Auto (system default)">auto_mode</span>
            </a>
            <a class="dropdown-item" href="#" data-icon="bi-brightness-high" data-value="default">
                <i class="bi-brightness-high me-2"></i>
                <span class="text-truncate" title="Default (light mode)">default_mode</span>
            </a>
            <a class="dropdown-item active" href="#" data-icon="bi-moon" data-value="dark">
                <i class="bi-moon me-2"></i>
                <span class="text-truncate" title="Dark"> dark_mode</span>
            </a>
        </div>
    </div>
</template>
<script>
import ThemeColor from '../theme.js'
export default {
    name: 'ColorSwitcher',
    methods: {},
    mounted() {        ThemeColor.initToogler();

    }
}
</script>